import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';

/**
 * This pipe used to format to dd/MM/yyyy
 */
@Pipe({
  name: 'defaultDateFormatPipe',
})
export class DefaultDateFormatPipe extends DatePipe implements PipeTransform {
  DATE_FORMAT: string = 'dd/MM/yyyy';

  transform(value: any, args?: any): any | null {
    const datePipe = new DatePipe('en-US');
    try {
      return datePipe.transform(value, this.DATE_FORMAT);
    } catch (error) {
      return value;
    }
  }
}
